/**
 * ShoppingCartIcon constructor
 * @param {HTMLElement} element
 * @constructor
 */
import {Api} from "@/util/api";

export class ShoppingCartIcon {
	private _element:any;
	private _animationDuration: number = 3000;
	private _productCountElement:any;

	constructor(element:any) {
		this._element = element;
		this._element.classList.remove('updated');
		this._productCountElement = this._element.children[0];

		const iterationCount = 3;
		this._productCountElement.style.animationDuration = `${(this._animationDuration / iterationCount).toString(
			10
		)}ms`;
		this._productCountElement.style.animationIterationCount = iterationCount.toString(10);
		this._loadShoppingCart();
	}

	/**
	 * Method which loads the currently active shopping cart. Once the shopping cart has been loaded it calls the
	 * {@see updateProductCount} method below.
	 * @private
	 */
	_loadShoppingCart () {
		const me = this;

		Api.getInstance().getActiveShoppingCart().then((result) => {
			me._setProductCountOnElement(result)
		})
	};

	/**
	 * Method which updates the counter for the number of products.
	 * @param {{items: {articleCode: String, quantity: Number}[]}} newShoppingCart
	 */
	updateProductCount (newShoppingCart:any) {
		this._setProductCountOnElement(newShoppingCart);
		this._element.classList.add('updated');

		const me = this;
		setTimeout(function () {
			me._element.classList.remove('updated');
		}, this._animationDuration);
	};

	/**
	 * Method which updates the dom element relaying the change in the number of products within the shopping cart.
	 * @param {{items: {articleCode: String, quantity: Number}[]}} newShoppingCart
	 * @private
	 */
	_setProductCountOnElement (newShoppingCart:any) {
		const numberOfProducts = newShoppingCart.items.reduce((reduction:number, item:any) => {
			reduction += item.quantity;
			return reduction;
		}, 0);

		this._element.classList.remove('filled');

		if (numberOfProducts > 0) {
			this._element.classList.add('filled');
		}

		if (numberOfProducts > 99) {
			this._productCountElement.innerHTML = '99+';
		} else {
			this._productCountElement.innerHTML = `${numberOfProducts || 0}`;
		}
	};
}
